/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
*/
import dashboard from './dashboard'
// import wishlist from './wishlist'

// Komship
import dashboardKompship from './dashboard-kompship'
import produk from './produk'
import order from './order'
// import gudangkomship from './gudang-komship'
import gudangkompack from './gudang-kompack'
import pickup from './pickup'
import customer from './customer'
import settingKompship from './setting-kompship'
import keuangan from './keuangan'
import opsional from './opsional'
import myapps from './myapps'
import ticketingUser from './ticketing-user'
import inbox from './inbox'
import komads from './komads'
import team from './team'
import konten from './konten'

// import hiring from './hiring'

// Komship Admin
import komship from './komship'

// Komplace
import tiket from './tiket'
import notification from './notification'

// Kompack Admin
import kompackpartner from './kompack/partner'

// komtim
// import komtim from './komtim'

// online-store
import onlineStore from './online-store'

import { getUserData } from '@/auth/utils'

const userData = getUserData()
const isKomstoreOnly = userData?.is_komstore === 1 && !userData?.is_komship && !userData?.is_kompack && !userData?.is_komtim && !userData?.is_komads

let navMenu = []

const mapAuthResource = (arr) => arr.map(item => {
  const newItem = { ...item, action: 'read', resource: 'Public' }
  if (newItem.children) {
    newItem.children = mapAuthResource(newItem.children)
  }
  return newItem
})

if (isKomstoreOnly) {
  navMenu = mapAuthResource([
    ...dashboardKompship,
    ...produk,
    ...gudangkompack,
    ...onlineStore,
    ...keuangan,
    ...settingKompship,
    ...myapps,
  ])
} else {
  // Default for others
  navMenu = [
  ...dashboard,
  ...komship,
  ...kompackpartner,

  ...dashboardKompship,
  ...konten,
  ...inbox,
  ...komads,
  ...order,
  ...produk,
  // ...gudangkomship,
  ...gudangkompack,
  ...onlineStore,
  ...pickup,
  ...customer,
  ...keuangan,
  ...team,
  ...settingKompship,
  ...opsional,
  ...ticketingUser,
  ...myapps,
  // ...hiring,

    ...tiket,
    ...notification,
    // ...komtim,
  ]
}

export default navMenu
